@if (!!rl1Summary.id) {
    <ui-card>
        <app-segment-header title="payroll.taxReturns.rl1SummaryDetails" />
        <div class="flex col">
            <app-tax-return-summary-details-row
                label="payroll.taxReturns.lines.employeesQppContributions"
                [amount]="rl1Summary.totEmpeQppAmt"
            />
            <app-tax-return-summary-details-row
                label="payroll.taxReturns.lines.employersQppContributions"
                [amount]="rl1Summary.totEmprQppAmt"
            />
            <app-tax-return-summary-details-row
                label="payroll.taxReturns.lines.employeesQpp2Contributions"
                [amount]="rl1Summary.totEmpeQppeAmt"
            />
            <app-tax-return-summary-details-row
                label="payroll.taxReturns.lines.employersQpp2Contributions"
                [amount]="rl1Summary.totEmprQppeAmt"
            />
            <app-tax-return-summary-details-row
                label="payroll.taxReturns.lines.employeesQpipContributions"
                [amount]="rl1Summary.totEmpeQpipAm"
            />
            <app-tax-return-summary-details-row
                label="payroll.taxReturns.lines.employersQpipContributions"
                [amount]="rl1Summary.totEmprQpipAm"
            />
            <app-tax-return-summary-details-row
                label="payroll.taxReturns.lines.quebecIncomeTax"
                [amount]="rl1Summary.totItxDdctAmt"
            />
        </div>
    </ui-card>
}
